import nBossConnection from "modules/base/service/nBossConnection";
import EntityValidationResult from "modules/base/dto/validation/EntityValidationResult";
import PowellOptimizerEditDto from "../dto/PowellOptimizerEditDto";

class PowellOptimizerEditService {
    constructor() {
        this.connection = nBossConnection.connection;
        this.CONTROL = "powellOptimizerEditControl";
    }

    /**
     * @return {Promise<PowellOptimizerEditDto>}
     */
    create() {
        return new Promise((resolve, reject) => {
            this.connection
                .get(`/${this.CONTROL}/create`)
                .then((response) =>
                    resolve(new PowellOptimizerEditDto().setup(response.data))
                )
                .catch(reject);
        });
    }

    /**
     * @param {string} type
     * @return {Promise<PowellOptimizerEditDto>}
     */
    createByType(type) {
        return new Promise((resolve, reject) => {
            this.connection
                .get(`/${this.CONTROL}/create`)
                .then((response) =>
                    resolve(
                        new PowellOptimizerEditDto().setup({
                            ...response.data,
                            type,
                        })
                    )
                )
                .catch(reject);
        });
    }

    /**
     * @param {number} id
     * @return {Promise<PowellOptimizerEditDto>}
     */
    getData(id) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/getData`, {
                    id,
                })
                .then((response) =>
                    resolve(new PowellOptimizerEditDto().setup(response.data))
                )
                .catch(reject);
        });
    }

    /**
     * @param {PowellOptimizerEditDto} dto
     * @return {Promise<EntityValidationResult>}
     */
    save(dto) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/save`, {
                    dto,
                })
                .then((response) =>
                    resolve(new EntityValidationResult().setup(response.data))
                )
                .catch(reject);
        });
    }

    /** 
     * @param {number} id
     * @param {PowellOptimizerEditDto} dto
     * @return {Promise<EntityValidationResult>}
     */
    update(id, dto) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/update`, {
                    id,
                    dto,
                })
                .then((response) =>
                    resolve(new EntityValidationResult().setup(response.data))
                )
                .catch(reject);
        });
    }
}

export default new PowellOptimizerEditService();